import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import Swal from 'sweetalert2';
import { Project } from 'src/app/shared/models/project';
import { TabMenuLogicService } from 'src/app/shared/services/tab-menu.logic.service';
import { EEAOutputProjectInputsApiService } from 'src/app/shared/services/eea-output-project-inputs.api.service';
import { Constants } from 'src/app/shared/utils/constants';
import { Utils } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-eea-output',
  templateUrl: './eea-output.component.html',
  styleUrls: ['./eea-output.component.css']
})
export class EEAOutputComponent implements OnInit {

  @Input() selectedProject?:Project;
  @Input() menuService!: TabMenuLogicService;
  @Input() selectedProjectStatus?: number;
  @Input({required: true}) isProjectOwnershipValid: boolean = false;

  destroyRef = inject(DestroyRef)

  constructor(private runInputsApiService: EEAOutputProjectInputsApiService){}

  ngOnInit(){
    this.menuService.activeIndexChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.menuService.setSuccess(true));
    this.checkRustadPostProcessing();
  }

  private checkRustadPostProcessing(): void {
    if (!this.selectedProject?.projectPk)
      return;

    this.runInputsApiService
      .getRunInputsUseInCalculation(this.selectedProject.projectPk)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (runInputs: any[]) => {
          if (this.hasRustadMacroGWRun(runInputs) && !Swal.isVisible())
            Utils.showRustadPostProcessingAlert();
        },
        error: (error: any) => console.warn(error)
      });
  }

  private hasRustadMacroGWRun(runInputs: any[]): boolean {
    return (runInputs ?? []).some(
      (runInput: any) =>
        runInput?.model === Constants.MODELS.MACRO_GW &&
        Utils.isRustadLocation(runInput?.location)
    );
  }
}
